<div class="page-header">
	<button mat-flat-button color="primary" (click)="onNewBroker()">
		<mat-icon>add</mat-icon>
		<span>Nova Corretora</span>
	</button>
</div>

<div class="search-form" [formGroup]="searchForm">
	<mat-form-field
		class="search-field"
		title="Busca de corretoras"
		appearance="outline"
	>
		<mat-label>Buscar por nome ou CNPJ...</mat-label>
		<input
			type="text"
			matInput
			placeholder="Buscar por nome ou CNPJ..."
			formControlName="term"
		/>
		<mat-icon matSuffix>search</mat-icon>
	</mat-form-field>
</div>

<div
	*ngIf="{ brokers: brokers$ | async, isLoading: isLoading$ | async } as data"
>
	<div class="loader" *ngIf="data.isLoading">
		<mat-spinner diameter="30"></mat-spinner>
	</div>

	<ng-container *ngIf="!data.isLoading">
		<div
			*ngIf="data.brokers && data.brokers.length > 0; else emptyState"
			class="table-container"
		>
			<div class="table-header">
				<div class="table-cell name">Nome da Corretora</div>
				<div class="table-cell cnpj">CNPJ</div>
				<div class="table-cell orgs">Organizações</div>
				<div class="table-cell beneficiaries">Beneficiários</div>
				<div class="table-cell actions">Ações</div>
			</div>
			<div
				class="table-row-wrapper"
				*ngFor="let broker of data.brokers; trackBy: trackByBrokerId"
			>
				<div class="table-row">
					<div class="table-cell name">{{ broker.name_secondary }}</div>
					<div class="table-cell cnpj">
						{{ broker.cnpj | mask: '00.000.000/0000-00' }}
					</div>
					<div class="table-cell orgs">
						{{ broker.linkedOrganizationsCount }}
					</div>
					<div class="table-cell beneficiaries">
						{{ broker.totalBeneficiaries || 0 | number }}
					</div>
					<div class="table-cell actions">
						<button
							mat-icon-button
							(click)="onLink(broker)"
							matTooltip="Vincular Organização"
						>
							<mat-icon>link</mat-icon>
						</button>
						<button
							mat-icon-button
							(click)="onUnlink(broker)"
							matTooltip="Desvincular Organização"
							[disabled]="!broker.linkedOrganizationsCount"
						>
							<mat-icon>link_off</mat-icon>
						</button>
						<button
							mat-icon-button
							(click)="onEdit(broker)"
							matTooltip="Editar Corretora"
						>
							<mat-icon>edit</mat-icon>
						</button>
						<button
							mat-icon-button
							color="warn"
							(click)="onDelete(broker)"
							matTooltip="Excluir Corretora"
						>
							<mat-icon>delete_outline</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>

		<ng-template #emptyState>
			<div class="empty-state">
				<p>
					{{
						searchForm.get('term')?.value
							? 'Nenhuma corretora encontrada.'
							: 'Nenhuma corretora cadastrada.'
					}}
				</p>
			</div>
		</ng-template>
	</ng-container>
</div>
